import React, { useState, useEffect } from 'react';
import cx from 'classnames';

import { aside, panel, panelWithTopBanner } from './aside-panel.module.scss';

export default function AsidePanel({ children }) {
  const [isTopBanner, setIsTopBanner] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      const topBanner = document.getElementById('top-banner-close');
      topBanner && setIsTopBanner(true);
      topBanner &&
      topBanner.addEventListener('click', () => {
        setIsTopBanner(false);
      });
    }, 0);
  }, []);
  return (
    <aside className={aside}>
      <div className={isTopBanner ? cx(panel, panelWithTopBanner) : panel}>{children}</div>
    </aside>
  );
}
